module.exports = __webpack_public_path__ + "media/images/mobile/Mask Group 5-970ef483752cde67352b0d90c5f42dec.png";